<clx-row type="buttons">
    <clx-button class="button-padding"
        test-id="sites.button.new-batchupgrade"
        has-privileges="SiteBatchUpgrade"
        i18n="@@operating.datagrid.plants.new-batch-upgrade.button"
        [routerLink]="['/Administration/Upgrade/Schedule']"
    >New Batch upgrade</clx-button>
    <clx-button class="button-padding"
        test-id="sites.button.batchupgrades-export"
        has-privileges="SiteBatchUpgrade"
        i18n="@@operating.datagrid.plants.batch-upgrades-export.button"
        (onClick)="showExportDialog()"
    >Export</clx-button>
</clx-row>
<clx-data-grid    
    [data]="source"
    [showFilter]="true"
    [showSearchPanel]="false"
    [showGroupPanel]="true"
    [version]="1"
    [id]="id"
    #grid
    [remoteOperations]="remoteOperations"
    [test-id]="testId"
>

    <clx-grid-column
        dataField="Name"
        i18n-caption="@@batchupgrade-list.name"
        [test-id]="testId + '.name'"
        caption="Name"
        dataType="string"
    >
        <ng-template let-data="item">
            <a [routerLink]="['/Administration/Upgrade/' + data.row.data.SiteBatchUpgradeId]">{{data.value}}</a>
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="StartDateUtc"
        i18n-caption="@@batchupgrade-list.start"
        [test-id]="testId + '.start'"
        [allowFiltering]="true"
        [allowGrouping]="false"
        caption="Start"
        alignment="center"
        dataType="datetime"
    >
        <ng-template let-data="item">
          {{data.value | datetimeUtcToLocal | datetime: 'L LT'}}
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="EndDateUtc"
        i18n-caption="@@batchupgrade-list.end"
        [test-id]="testId + '.end'"
        [allowFiltering]="true"
        [allowGrouping]="false"
        caption="End"
        alignment="center"
        dataType="datetime"
    >
        <ng-template let-data="item">
            {{data.value | datetimeUtcToLocal | datetime: 'L LT'}}
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="ScheduledSites"
        i18n-caption="@@batchupgrade-list.scheduled"
        [test-id]="testId + '.scheduled'"
        caption="Scheduled"
        alignment="center"
        dataType="number"
    >   
        <ng-template let-data="item">
            {{data.value}}
        </ng-template>
        <ng-template #headerCellTemplate let-data="item">
            <i class="icon-link fa fa-clock-o"></i>
            &nbsp; <span i18n="@@batchupgrade-list.scheduled">Scheduled</span>
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="RunningSites"
        i18n-caption="@@batchupgrade-list.running"
        [test-id]="testId + '.running'"
        caption="Running"
        alignment="center"
        dataType="number"
    >
        <ng-template let-data="item">
            {{data.value}}
        </ng-template>
        <ng-template #headerCellTemplate let-data="item">
            <i class="icon-link fa fa-play"></i>
            &nbsp;<span i18n="@@batchupgrade-list.running">Running</span>
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="SucceededSites"
        i18n-caption="@@batchupgrade-list.succeeded"
        [test-id]="testId + '.succeeded'"
        caption="Succeeded"
        alignment="center"
        dataType="number"
    >
        <ng-template let-data="item">
            {{data.value}}
        </ng-template>
        <ng-template #headerCellTemplate let-data="item">
            <i class="icon-link fa fa-check"></i>
            &nbsp; <span i18n="@@batchupgrade-list.succeeded">Succeeded</span>
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="FailedSites"
        i18n-caption="@@batchupgrade-list.failed"
        [test-id]="testId + '.failed'"
        caption="Failed"
        alignment="center"
        dataType="number"
    >
        <ng-template let-data="item">
            {{data.value}}
        </ng-template>
        <ng-template #headerCellTemplate let-data="item">
            <i  class="icon-link fa fa-exclamation-triangle"></i>
            &nbsp; <span i18n="@@batchupgrade-list.failed">Failed</span>
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="CancelledSites"
        i18n-caption="@@batchupgrade-list.cancelled"
        [test-id]="testId + '.cancelled'"
        caption="Cancelled"
        alignment="center"
        dataType="number"
    >
        <ng-template let-data="item">
            {{data.value}}
        </ng-template>
        <ng-template #headerCellTemplate let-data="item">
            <i class="icon-link fa fa-times"></i>
            &nbsp; <span i18n="@@batchupgrade-list.cancelled">Cancelled</span>
        </ng-template>
    </clx-grid-column>
    <clx-grid-column
        dataField="SkippedSites"
        i18n-caption="@@batchupgrade-list.skipped"
        [test-id]="testId + '.skipped'"
        caption="Skipped"
        alignment="center"
        dataType="number"
    >
        <ng-template let-data="item">
            {{data.value}}
        </ng-template>
        <ng-template #headerCellTemplate let-data="item">
            <i class="icon-link fa fa-share"></i>
            &nbsp; <span i18n="@@batchupgrade-list.skipped">Skipped</span>
        </ng-template>
    </clx-grid-column>
</clx-data-grid>

<clx-popover
    class="popup"
    [minWidth]="600"
    [minHeight]="300"
    height="80%"
    width="80%"
    title="Export batch upgrades"
    [(visible)]="exportDialogVisible"
>
    <div class="batch-upgrade-list-export-popover">
        <clx-form (saved)="doExport($event)" disableChangeChecking="true">
            <clx-row>
                <clx-label>Criteria:</clx-label>
                <clx-radio name="exportCriteria" #criteria (change)="exportSelectorChanged()" test-id="export.batchupgradestatus.criteria.selector">
                    <clx-value value="DateTime" test-id="export.batchupgradestatus.criteria.selector.bydate">Date/Time</clx-value>
                    <clx-value value="GuidList" test-id="export.batchupgradestatus.criteria.selector.bylist">list of batches</clx-value>                    
                </clx-radio>
            </clx-row>
            <clx-row *ngIf="criteria.value === 'DateTime'">
                <clx-label i18n="@@export.batchupgradestatus.label.startdatetime">Export batch upgrades after (utc)</clx-label>
                <clx-datetime 
                name="startTime"
                #startTime
                todayButtonText="Now" i18n-todayButtonText="@@administration.upgrades.export.bydate.button.now"
                [returnUTCDate]="true"
                [max]="" [min]="" 
                type="datetime"   
                (change)="exportStartDateTimeChanged($event)"              
                test-id="export.start-upgrade-window.starttime.input">
                    <clx-validation type="datetime"></clx-validation>
                    <clx-validation type="required"></clx-validation>
                </clx-datetime>
            </clx-row>
            <clx-row class="stretch-grid" *ngIf="criteria.value === 'GuidList'" has="full-size-columns">
                <clx-item>
                    <clx-data-grid    
                        [data]="exportSource"
                        [showFilter]="true"
                        [showSearchPanel]="false"
                        [showGroupPanel]="true"                        
                        [version]="1"
                        height="100%"
                        id="exportId"
                        #gridSelect
                        [remoteOperations]="exportRemoteOperations"
                        [test-id]="exportTestId"
                    >
                        <clx-grid-column
                            dataField="SiteBatchUpgradeId"
                            i18n-caption="@@batchupgrade-list.name"
                            [test-id]="exportTestId + '.select'"
                            caption="Select"
                            [allowFiltering]="false"
                            [allowGrouping]="false"
                            [allowHiding]="false"
                            [allowSorting]="false"
                            dataType="string"
                            >
                            <ng-template let-data="item">                            
                                <clx-checkbox                                                                 
                                    [values]="[{ key : true, value: data.row.data.SiteBatchUpgradeId}, {key : false, value : null}]"
                                    [checked]="(selectAllBatches || selectedBatches.includes(data.row.data.SiteBatchUpgradeId)) ? true : false"
                                    name="select-batch"
                                    #batchCheckboxes
                                    [test-id]="'administration.upgrades.export.select-batch.checkbox.' + data.row.data.SiteBatchUpgradeId"
                                    (valueChanged)="selectBatch($event, data.row.data.SiteBatchUpgradeId, batchCheckboxes)"
                                >
                                </clx-checkbox>                        
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <clx-checkbox
                                    [checked]="selectAllBatches"
                                    #changeAllBox
                                    test-id="administration.upgrades.export-select-all-batches.checkbox"
                                    name="select-batch"
                                    (valueChanged)="changeAllBatchesSelection($event)"
                                ></clx-checkbox><span i18n="@@administration.upgrades.export.selectallbatches">Select all batches</span>
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="Name"
                            i18n-caption="@@batchupgrade-list.name"
                            [test-id]="exportTestId + '.name'"
                            caption="Name"
                            dataType="string"
                            >
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="StartDateUtc"
                            i18n-caption="@@batchupgrade-list.start"
                            [test-id]="exportTestId + '.start'"
                            [allowFiltering]="true"
                            [allowGrouping]="false"
                            caption="Start"
                            alignment="center"
                            dataType="datetime"
                        >
                            <ng-template let-data="item">
                            {{data.value | datetimeUtcToLocal | datetime: 'L LT'}}
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="EndDateUtc"
                            i18n-caption="@@batchupgrade-list.end"
                            [test-id]="exportTestId + '.end'"
                            [allowFiltering]="true"
                            [allowGrouping]="false"
                            caption="End"
                            alignment="center"
                            dataType="datetime"
                        >
                            <ng-template let-data="item">
                                {{data.value | datetimeUtcToLocal | datetime: 'L LT'}}
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="ScheduledSites"
                            i18n-caption="@@batchupgrade-list.scheduled"
                            [test-id]="exportTestId + '.scheduled'"
                            caption="Scheduled"
                            alignment="center"
                            dataType="number"
                        >   
                            <ng-template let-data="item">
                                {{data.value}}
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <i class="icon-link fa fa-clock-o"></i>
                                &nbsp; <span i18n="@@batchupgrade-list.scheduled">Scheduled</span>
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="RunningSites"
                            i18n-caption="@@batchupgrade-list.running"
                            [test-id]="exportTestId + '.running'"
                            caption="Running"
                            alignment="center"
                            dataType="number"
                        >
                            <ng-template let-data="item">
                                {{data.value}}
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <i class="icon-link fa fa-play"></i>
                                &nbsp;<span i18n="@@batchupgrade-list.running">Running</span>
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="SucceededSites"
                            i18n-caption="@@batchupgrade-list.succeeded"
                            [test-id]="exportTestId + '.succeeded'"
                            caption="Succeeded"
                            alignment="center"
                            dataType="number"
                        >
                            <ng-template let-data="item">
                                {{data.value}}
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <i class="icon-link fa fa-check"></i>
                                &nbsp; <span i18n="@@batchupgrade-list.succeeded">Succeeded</span>
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="FailedSites"
                            i18n-caption="@@batchupgrade-list.failed"
                            [test-id]="exportTestId + '.failed'"
                            caption="Failed"
                            alignment="center"
                            dataType="number"
                        >
                            <ng-template let-data="item">
                                {{data.value}}
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <i  class="icon-link fa fa-exclamation-triangle"></i>
                                &nbsp; <span i18n="@@batchupgrade-list.failed">Failed</span>
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="CancelledSites"
                            i18n-caption="@@batchupgrade-list.cancelled"
                            [test-id]="exportTestId + '.cancelled'"
                            caption="Cancelled"
                            alignment="center"
                            dataType="number"
                        >
                            <ng-template let-data="item">
                                {{data.value}}
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <i class="icon-link fa fa-times"></i>
                                &nbsp; <span i18n="@@batchupgrade-list.cancelled">Cancelled</span>
                            </ng-template>
                        </clx-grid-column>
                        <clx-grid-column
                            dataField="SkippedSites"
                            i18n-caption="@@batchupgrade-list.skipped"
                            [test-id]="exportTestId + '.skipped'"
                            caption="Skipped"
                            alignment="center"
                            dataType="number"
                        >
                            <ng-template let-data="item">
                                {{data.value}}
                            </ng-template>
                            <ng-template #headerCellTemplate let-data="item">
                                <i class="icon-link fa fa-share"></i>
                                &nbsp; <span i18n="@@batchupgrade-list.skipped">Skipped</span>
                            </ng-template>
                        </clx-grid-column>
                    </clx-data-grid>
                </clx-item>
            </clx-row>
            <clx-row type="buttons"
            >                
                <clx-button (click)="exportDialogVisible = false; exportButtonDisabled=true;" test-id="export.batchupgradestatus.buttons.cancel">Cancel</clx-button>
                <clx-button                 
                [disabled]="exportButtonDisabled ? true : null"
                test-id="export.batchupgradestatus.buttons.export"                
                type="save">{{exportButtonText}}</clx-button>
            </clx-row>
        </clx-form>
    </div>
</clx-popover>